import React, { Component } from 'react'
import ContactSvg from '../svgs/ContactSvg'
import CloseSvg from '../svgs/CloseSvg';
import { connect } from 'react-redux';
import { getApplyOptions, insertNewData } from '../../actions/MainAction';
import { mixinAlert } from '../../actions/Alerts';
import SendSvg from '../svgs/SendSvg';
import { changeStateValue } from '../../redux/MainReducer';

export class TrainingReturn extends Component {
    state = {
        visible: false,
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        btnDisable: false
    }
    componentDidMount() {
        this.props.getApplyOptions()
    }
    // applyBtn(data, publicOption) {
    //     if (data?.first_name != '' && data?.last_name != '' && data?.email != '' && data?.phone_number != '') {
    //         this.setState({ btnDisable: true })
    //         let formData = new FormData();
    //         for (const property in data) {
    //             formData.append(property, data[property])
    //         }
    //         formData.append('training_id', this.props.trainingId)
    //         let x = ``;
    //         for (const y of publicOption) {
    //             if (y?.value) {
    //                 x += `${y?.title}: ${y?.value}\n\n`
    //             }
    //         }
    //         formData.append("options", x);
    //         let url = 'public-traning-apply';
    //         this.props.insertNewData(url, formData)
    //             .then(resp => {
    //                 this.setState({ btnDisable: false })

    //                 this.setState({
    //                     first_name: '',
    //                     last_name: '',
    //                     email: '',
    //                     phone_number: '',
    //                     visible: false
    //                 })
    //                 if (resp == 'success') {
    //                     mixinAlert('success', "Müraciətiniz göndərildi.");
    //                 } else {
    //                     mixinAlert('error', "Xəta başverdi.");
    //                 }
    //             })
    //     } else {
    //         mixinAlert('error', "Zəhmət olmasa bütün xanaları doldurun.");
    //     }
    // }


    applyBtn(data, publicOption) {
        if (data?.first_name !== '' && data?.last_name !== '' && data?.email !== '' && data?.phone_number !== '') {
            this.setState({ btnDisable: true });

            let formData = new FormData();
            for (const property in data) {
                formData.append(property, data[property]);
            }
            formData.append('training_id', this.props.trainingId);

            let x = '';
            for (const y of publicOption) {
                if (y?.value) {
                    x += `${y?.title}: ${y?.value}\n\n`;
                }
            }
            formData.append('options', x);

            const botToken = '7653840631:AAFj9DHxuNQopqrmos9EwyyqkXxhR7jZuus';
            const chatId = '-1002399568151';
            const message = ` 📩 Təlim paketi:${this.props.training_title}\n\n 🧑Ad: ${data.first_name} ${data.last_name}\n 📧 Email: ${data.email}\n 📱 Əlaqə nömrəsi: ${data.phone_number}\n\n${x}`;

            const path = `https://api.telegram.org/bot${botToken}/sendMessage`;

            fetch(path, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    chat_id: chatId,
                    text: message,
                    parse_mode: 'HTML'
                })
            })
                .then(response => response.json())
                .then(resp => {
                    this.setState({
                        first_name: '',
                        last_name: '',
                        email: '',
                        phone_number: '',
                        visible: false
                    });
                    if (resp.ok) {
                        mixinAlert('success', 'Müraciətiniz göndərildi.');
                    } else {
                        mixinAlert('error', 'Müraciətinizdə xəta baş verdi.');
                    }
                })
                .catch(error => {
                    mixinAlert('error', 'Şəbəkə xətası: ' + error.message);
                });

            let url = 'public-traning-apply';
            this.props.insertNewData(url, formData)
                .then(resp => {
                    this.setState({ btnDisable: false });
                    if (resp === 'success') {
                        // mixinAlert('success', 'Müraciətiniz göndərildi.');
                    } else {
                        // mixinAlert('error', 'Xəta başverdi.');
                    }
                });
        } else {
            mixinAlert('error', 'Zəhmət olmasa bütün xanaları doldurun.');
        }
    }


    chamgeInp = (i, e) => {
        this.props.changeStateValue({
            name: `publicOption.${i}.value`,
            value: e.target.value
        })
    }
    render() {
        const { visible, first_name, last_name, email, phone_number, btnDisable } = this.state;
        const { publicOption, training_title } = this.props;
        // console.log(training_title)
        return (
            <div className='training_return_cont'>
                {
                    // visible?
                    <div style={{ height: visible ? '435px' : '0px', padding: visible ? '20px' : '0px' }} className='training_return_inp_cont'>
                        <div className='grid-2-mini student_return'>
                            <div className='inp_container'>
                                <label htmlFor='firstName'>Ad</label>
                                <input value={first_name} onChange={(e) => this.setState({ first_name: e.target.value })} type='text' id='firstName' placeholder='Ad' />
                            </div>
                            <div className='inp_container'>
                                <label htmlFor='lastName'>Soyad</label>
                                <input value={last_name} onChange={(e) => this.setState({ last_name: e.target.value })} type='text' id='lastName' placeholder='Soyad' />
                            </div>
                            <div className='inp_container'>
                                <label htmlFor='email'>E-poçt</label>
                                <input value={email} onChange={(e) => this.setState({ email: e.target.value })} type='email' id='email' placeholder='E-poçt' />
                            </div>
                            <div className='inp_container'>
                                <label htmlFor='phone_number'>Əlaqə nömrəsi</label>
                                <input value={phone_number} onChange={(e) => this.setState({ phone_number: e.target.value })} type='tel' id='phone_number' placeholder='Əlaqə nömrəsi' />
                            </div>
                            {
                                publicOption?.map((data, i) => {
                                    return (
                                        <div key={i} className='inp_container'>
                                            <label htmlFor='phone_number'>{data?.title}</label>
                                            <input value={data?.value ? data?.value : ''} onChange={this.chamgeInp.bind(this, i)} type='tel' id='phone_number' placeholder={data?.title} />
                                        </div>
                                    )
                                })
                            }
                            <button disabled={btnDisable} className='apply_button' onClick={this.applyBtn.bind(this, this.state, publicOption)}>Göndər</button>
                        </div>
                    </div>
                }

                <button onClick={() => this.setState({ visible: !visible })} className='training_return_cont_btn'>
                    {/* {
                visible? <CloseSvg />: <ContactSvg />
            } */}
                    <SendSvg /> Müraciət et
                </button>
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    publicOption: state.Data.publicOption
})
const mapDispatchToProps = { getApplyOptions, changeStateValue, insertNewData }
export default connect(mapStateToProps, mapDispatchToProps)(TrainingReturn)
